module.exports = __webpack_public_path__ + "img/Kid1.6a4ec756.png";